<template>
  <div class="hello">
    <div class="box"  @scroll.passive="getScroll($event)">
      <!-- 头部 -->
        <!-- <div class="thehead-box">
            <div class="thehead">
               <div class="img-box">
                  <img class="imge" src="../image/icon2.png">
                 </div> 
                <div class="thehead-box2">
                      <span class="thehead-fengt">大会介绍</span>
                      <span class="thehead-fengt">特色活动</span>
                      <span class="thehead-fengt">新闻资讯</span>
                      <span class="thehead-fengt">我要参赛</span>
                </div>
            </div> -->
             <headTail :banquanType='banquanType' ></headTail>
          <!-- 跳转结束 -->
          <!-- <div class="thehead-body"> -->
              <div class="body-box">
                 <div class="videos">
                    	<video 	 poster="../image/feng.jpg" height="100%" ref="videoRef"  width="100%"  controls style="width= 100%; height=100%; object-fit: fill" :src="video"  @play="videoIsPlay = true;" @pause="videoIsPlay = false;" @ended="videoIsPlay = false;"/>
                      <i
                        class="start-play"
                        v-show="!videoIsPlay"
                        @click="changeVideoStatus()"
                        >
                      </i>
                  </div>
                  <!-- <div class="videos">
                    <video height="100%" width="100%" style="width= 100%; height=100%; object-fit: fill" controls="controls" objectFit="cover" :src="video"/>
                  </div> -->
                  <!-- <img class="body-box-img" src="../image/icon10.png"> -->
              </div>
             
          <!-- </div> -->
           <!-- 大赛介绍 -->
        <div class="introduce" v-animate="'slide-top'">
          <div class="jkrt">
            <div class="introduce-box loiss2" style="text-align: left;">
              <div class="loi lojius" style="font-size: 40px;width:250px" ref="lightBtn">大赛简介</div>
            </div>
            <div class="wenzi">
                <div class="wenzibox1" style="margin-bottom:30px ;font-size: 17px;">
                    “这礼是成都”文化创意产品设计大赛是成都博物馆精心打造的赛事品牌。旨在深入发掘馆藏文化资源，通过“文物 IP”与“设计”嫁接，打造代表四川，属于成都的文化礼物，活化历史文化，实现博物馆文化与城市文化共生，不断满足人民对美好生活的向往。
                  <div class="zuop" style="font-size: 17px; padding-bottom:5px">
                    主办单位：
                    <span style="font-size: 17px;font-weight: 400;">成都博物馆</span>
                  </div>
                    <div class="zuop" style="font-size: 17px; padding-bottom:5px">
                    承办单位：
                    <span style="font-size: 17px;font-weight: 400;">成都金沙太阳神鸟文化发展有限责任公司、四川金手指造梦科技有限公司</span>
                  </div>
                     <div class="zuop" style="font-size: 17px; padding-bottom:5px">
                      线上唯一合作平台：
                    <span style="font-size: 17px;font-weight: 400;">文创云集</span>
                  </div>
                   <div class="zuop" style="font-size: 17px; padding-bottom:5px">
                     合作对象：
                    <span style="font-size: 17px;font-weight: 400;">合景·摩方（成都）、蜀之源酒业、高淳陶瓷、茂县羌绣、拙品、北川巴拿恰文创、鹃城牌郫县豆瓣、宽厚</span>
                  </div>
                  <div class="zuop" style="font-size: 17px; padding-bottom:5px">
                     支持单位：
                    <span style="font-size: 17px;font-weight: 400;">虎马传媒、贺阳导演工作室、鬼马创意、四川慕茗鼎尚、神佑app、天府文创云</span>
                  </div>
                </div> 
            </div>
            
             <div class="introduce-box-hen1" style=" width: 352px;
height: 1px;"></div>
                <div class="introduce-box-hen2" style="width: 72%;
height: 1px;"></div>
                <div class="introduce-box-hen3" style="left: 210px;
 width: 1px;"></div>
          </div>
             <div class="jkrt" style="padding:0px">
                <div class="introduce-box loiss2" style="text-align: left;">
                  <div class="loi lojius" style="font-size: 40px;width:250px" ref="lightBtn">大赛主题</div>
                 
                </div>
                <div class="wenzi">
                    <div style="font-size: 17px;">
                    “成都微笑迎大运”
                  </div>
                    <div class="wenzibox1" style="margin-bottom:81px ;font-size: 17px;">
                  以成都博物馆一批微笑的馆藏陶俑为主要创意元素，同时结合城市事件——大运会，展现成都穿越千年的微笑，让古代成都的人文气质走进现代成都。
                    </div>
                </div>
                <div class="introduce-box-hen11" style=" width: 352px;
                    height: 1px;"></div>
                    <div class="introduce-box-hen12" style=" width: 72%;
                     height: 1px;"></div>
                    <div class="introduce-box-hen13" style="left: 210px;
                    width: 1px;height: 180px;"></div>
          </div>
          <div class="jkrt" style="padding:0px">
                <div class="introduce-box loiss2" style="text-align: left;">
                  <div class="loi lojius" style="font-size: 40px;width:250px" ref="lightBtn">参赛对象</div>
                </div>
                <div class="wenzi">
                    <div class="wenzibox1" style="margin-bottom:81px ;font-size: 17px;">
                    致力于文化创意设计和研发的企业、设计机构、院校、设计公司和设计师、发明人、专利持有者、工艺美术师、手工艺制作者、艺术从业者、院校师生等均可免费参赛，也可以共同创作、联名参赛。
                    </div>
                </div>
                <div class="introduce-box-hen11" style=" width: 352px;
                    height: 1px;"></div>
                    <div class="introduce-box-hen12" style=" width: 72%;
                     height: 1px;"></div>
                    <div class="introduce-box-hen13" style="left: 210px;
                    width: 1px;height: 180px;"></div>
          </div>
            <div class="jkrt" style="padding:0px">
            <div class="introduce-box loiss2" style="text-align: left;">
              <div class="loi lojius" style="font-size: 40px;width:250px" ref="lightBtn">赛事内容</div>
            </div>
            <div class="wenzi">
                <div class="wenzibox1" style="margin-bottom:30px; font-size: 17px;" >
                  <div class="zuop" style="font-size: 20px; padding-bottom:5px">
                   (一) 文创设计类
                  </div>
                  <div>
                   1.【成都微笑·共创生活】
                  </div>
                   本赛道要求参赛者根据大赛官网发布的素材，以成都博物馆馆藏陶俑结合“成都微笑”为主要设计方向，进行文创产品设计。要求产品突出成博特色和成都文化特色，形态新颖、市场接受度高、易打样生产。
                 </div>
                <div class="wenzibox1" style="font-size: 17px;">
                      <div>
                   2.【成都微笑·共享成博】
                      </div>
                   本赛道要求参赛者根据大赛官网发布的素材，以成都博物馆馆藏陶俑结合“成都微笑”为主要设计方向，进行平面设计创作，包括但不限于能够代表成博的IP形象、包装设计、海报、插画、表情包、VI设计、壁纸等。
                </div>
                <div class="wenzibox1" style="font-size: 17px;" >
                  <div class="zuop" style="font-size: 20px; padding-bottom:5px;margin-top:30px">
                (二) 文创摄影类
                  </div>
                  <div>
                  【喜迎大运·共建未来】
                  </div>
               以运动项目为创意元素，进行短视频及摄影图片的创作。结合喜迎大运展示成都人民热爱运动、健康生活、乐观向上的精神面貌，呈现出运动成都、人文成都、生态成都。内容包括但不限于街拍、诗朗诵、语言表达、歌曲、舞蹈、MV、小戏小品、广播微剧、纪实影像等短视频，或搞笑、或抒情、或剧情均可。所有参赛作品应契合成都博物馆的整体形象，内容健康积极向上，符合社会主义核心价值观。
                 </div>
            </div>
             <div class="introduce-box-hen11" style=" width: 352px;
height: 1px;"></div>
                <div class="introduce-box-hen12" style=" width: 72%;
height: 1px;"></div>
                <div class="introduce-box-hen13" style="left: 210px;
 width: 1px;height: 180px;"></div>
          </div>
        </div>
            <!-- 大赛介绍结束 -->
             <div class="introduce-boxss45"  style="margin-top:0px" v-animate="'slide-top'">
                 <div class="loi" style="font-size: 40px;color: #FFFFFF;width:160px" ref="lightBtn">奖项设置</div>
                  <div class="chendu" style="font-size: 20px;color: #FFFFFF;font-weight: 500;" ref="lightBtn">【成都微笑·共创生活】</div>
            <div class="jian-img" >
                <img class="body-box-imgss" src="../image/jin.png">
                 <img class="body-box-imgss" src="../image/jin2.png">
                  <img class="body-box-imgss" src="../image/jin3.png">
                   <!-- <img style="padding-right:0px" class="body-box-imgss" src="../image/jin4.png"> -->
            </div>
             <div class="chendu2" style="font-size: 20px;color: #FFFFFF;font-weight: 500;" ref="lightBtn">【成都微笑·共享成博】</div>
              <div class="jian-img" >
                <img class="body-box-imgss" src="../image/jin.png">
                 <img class="body-box-imgss" src="../image/jin2.png">
                  <img class="body-box-imgss" src="../image/jin3.png">
                   <!-- <img style="padding-right:0px" class="body-box-imgss" src="../image/jin4.png"> -->
            </div>
              <div class="chendu2" style="font-size: 20px;color: #FFFFFF;font-weight: 500;" ref="lightBtn">【喜迎大运·共建未来】</div>
              <div class="jian-img" >
                <img class="body-box-imgss" src="../image/jin4.png">
                 <img class="body-box-imgss3" src="../image/jin5.png">
                   <!-- <img style="padding-right:0px" class="body-box-imgss" src="../image/jin4.png"> -->
            </div>
             <div class="chendu2" style="font-size: 20px;color: #FFFFFF;font-weight: 500;" ref="lightBtn">注：
2021“这礼是成都”微笑大使为大赛宣传配套活动，相关规则随宣传活动另行公布</div>
        </div>
         <!-- 进程规则div -->
    <div class="introduce-boxss456"  style="margin-top:0px" v-animate="'slide-top'">
        <div class="introduce-box loiss2" style="text-align: left;">
              <div class="loi lojius fonsiop2" style="font-size: 25px;width:100px" ref="lightBtn">评审规则</div>
          </div>
          <div class="wenzi wenzio">
                  <div class="wenzibox1" style="margin-bottom:30px ;font-size: 17px;">
                         <div class="zuop" style="font-size: 20px; padding-bottom:5px;">
                            大赛初审
                        </div>
                     由组委会对所有参赛作品进行初步评选，评选出 100 份入围作品。
                    </div>
                       <div class="wenzibox1" style="margin-bottom:30px ;font-size: 17px;">
                         <div class="zuop" style="font-size: 20px; padding-bottom:5px;">
                           网络投票
                        </div>
                      作品入围后，将在2022年1月1日-10日进行网络投票。可通过【成都博物馆】“这礼是成都”板块进行网络投票。
                    </div>
                     <div class="wenzibox1" style="margin-bottom:30px ;font-size: 17px;">
                         <div class="zuop" style="font-size: 20px; padding-bottom:5px;">
                           大赛终审
                        </div>
                        <div>
                        由网络公开投票(最高30%) +专家评审(70%) 的综合得分评出最终的获奖作品。
                        </div>
                       
                    </div>
                      <div class="wenzibox1" style="font-size: 17px;">
                         <div class="zuop" style="font-size: 20px; padding-bottom:5px;">
                         评审标准
                        </div>
                        <div style="margin-bottom:5px">
                          <span style="font-weight: bold;">设计感</span>
                         （20分）—— 构图饱满、色彩和谐、美术执行完整；
                        </div>
                         <div style="margin-bottom:5px">
                          <span style="font-weight: bold;">实用性</span>
                         （20分）—— 作品需具有可实施性，能被制造或使用，具备一定的商业价值；
                        </div>
                         <div style="margin-bottom:5px">
                          <span style="font-weight: bold;">创意性</span>
                         （15分）—— 作品内容立意新颖，有独特的视角，脑洞大开地将成都博物馆的文化与产品应用相结合，表达立意完整；
                        </div>
                          <div>
                        <span style="font-weight: bold;">文化感</span>
                          （15分）—— 充分体现成都博物馆馆藏魅力，设计源于馆藏，通过挖掘成都文化，传递城市性格。
                        </div>
                    </div>
          </div>
    </div>
        <!-- 大赛进程 -->
    <div class="introduce-boxss4567"  style="margin-top:0px" v-animate="'slide-top'">
        <div class="introduce-box loiss2" style="text-align: left;">
              <div class="loi" style="font-size: 40px;width:160px" ref="lightBtn">大赛进程</div>
        </div>
         <div class="jiu">
                <div class="jiu-box jiu-box2" style="justify-content: space-around;">
                    <img class="body-box-imgs2" src="../image/icon9.png">
                    <img class="body-box-imgs2" src="../image/icon4.png">
                    <!-- <img class="body-box-imgs2" src="../image/icon8.png"> -->
                </div>
                <div  class="jiu-box">
                    <img class="body-box-imgs2" src="../image/icon8.png">
                    <img class="body-box-imgs2" src="../image/icon7.png">
                    <img class="body-box-imgs2" src="../image/icon5.png">
                </div>
          </div>
    </div>
    <!-- 设计赛道 -->
    <div class="introduce-boxss45678"  style="margin-top:0px" v-animate="'slide-top'">
          <div class="loi lojius" style="font-size: 40px;width:250px;text-align: left;" ref="lightBtn">设计赛道</div>
          <div class="sheji">
              <div class="sheji-imgs">
                 <div class="she-dis">
                      <div class="sheji-wen" style="font-size: 22px;">文创设计类</div>
                      <!-- <div  class="sheji-wen2" style="font-size: 17px;line-height: 26px;">包含表情包、IP延伸、二次元、视频模板、对话、 框等线上使用类进行设计</div> -->
                  </div>
              </div>
                <div class="sheji-imgs2" >
                  <div class="she-dis2">
                      <div class="sheji-wen" style="font-size: 22px;">文创摄影类</div>
                      <!-- <div  class="sheji-wen2" style="font-size: 17px; line-height: 26px;">包含表情包、IP延伸、二次元、视频模板、对话、 框等线上使用类进行设计</div> -->
                  </div>
                  
                </div>
          </div>
           <div  class="ikju"  style="margin-top:0px">
                <div class="introduce-box loiss2" style="text-align: left;">
                      <div class="loi lojius" style="font-size: 25px;width:100px;text-align: left;" ref="lightBtn">报名方式</div>
                  </div>
                  <div class="wenzi wenzios3 wenzios" style="margin-left: 178px">
                        <div class="wenzibox1" style="font-size: 17px;padding-bottom: 8px;">
                          1．参赛作品提交截止日期: 2021年12月24日
                        </div>
                         <div class="wenzibox1" style="font-size: 17px;">
                          2．报名方式：所有参赛者通过点击右下角"素材下载"，下载比赛所用的设计素材、大赛须知、参赛承诺函等，进入"我要参赛"扫描二维码进行作品提交，请按照提示要求认真填写相关内容。
                        </div>
                  </div>
        </div>
         <div class="ikju"  style="margin-top:0px">
                <div class="introduce-box loiss2" style="text-align: left;">
                      <div class="loi lojius" style="font-size: 25px;width:150px;text-align: left;" ref="lightBtn">设计图纸要求</div>
                  </div>
                  <div class="wenzi wenzios2" style="margin-left: 124px;">
                        <!-- <div class="zuop" style="font-size: 20px;">
                            1. 作品商用、授权、素材使用等
                        </div> -->
                        <div class="wenzibox1 weji" style="font-size: 17px;">
                          <span style="font-size: 20px;">①</span>
                         A3横版/竖版的设计排版图，作品形式统一为电子稿，格式为jpg文件，宽度及高度不低于450px,分辨率300dpi以上，作品大小不超过5M，每份作品请附500字以内的设计说明;
                        </div>
                        <div class="wenzibox1 weji" style="font-size: 17px;">
                           <span style="font-size: 20px;">② </span>
                        参赛者自行保留作品矢量文件(CDR、AI、PSD等格式)，以便获奖后提交给组委会保存，如获奖设计师无法提供作品源文件，将取消获奖资格;
                        </div>
                          <div class="wenzibox1 weji" style="font-size: 17px;">
                           <span style="font-size: 20px;">③ </span>
                             所有参赛者/团队提交作品数量不限，团队参赛人数最多不能超过3位;
                        </div>
                          <div class="wenzibox1 weji" style="font-size: 17px;">
                           <span style="font-size: 20px;">④ </span>
                          所有提交参赛用的设计图纸不得出现以下内容:参赛者所在单位、姓名(包括英文或拼音缩写)或与参赛者身份有关的任何图标、图形等;
                        </div>
                           <div class="wenzibox1 weji" style="font-size: 17px;">
                           <span style="font-size: 20px;">⑤ </span>
                          视频上传须为完整的作品，需提交视频说明与视频文件，视频文件格式和内容需符合智能终端、手机等媒体播放，视频说明需包括主题、作品说明，视频单个文件大小不超过300M，时间不超过3分钟，格式MP4/MOV，分辨率不低于1080P；
                        </div>
                          <div class="wenzibox1 weji" style="font-size: 17px;">
                           <span style="font-size: 20px;"> ⑥</span>
                       摄影图片上传要求为JPG/PNG格式，作品大小不超过5M。
                        </div>
                         <div class="wenzibox1 weji" style="font-size: 17px;">
                           <span style="font-size: 17px; font-weight: bold;">  重要提示:</span>
                         本次大赛采用线上评审，请按尺寸要求上传图片，不接受rar/zip/7z等压缩包文件上传。
                        </div>
                </div>
        </div>
         <!-- <div  class="ikju kiki"  style="margin-top:0px">
                <div class="introduce-box loiss2" style="text-align: left;">
                    <div class="loi lojius" style="font-size: 25px;width:100px;text-align: left;" ref="lightBtn">参赛须知</div>
                </div>
                 <div class="wenzi wenzios3" style="margin-left: 170px">
                        <div class="wenzibox1 weji" style="font-size: 17px;">
                              1．大赛统一采取网络报名，根据页面提示和相关说明完成报名和作品提交流程;
                        </div>
                          <div class="wenzibox1 weji" style="font-size: 17px;">
                             2．参赛者在提交作品前请确保已阅读并愿意遵守相关比赛规则，任何违反规则的作品，主办方有权取消参赛资格;
                          </div>
                          <div class="wenzibox1 weji" style="font-size: 17px;">
                              3．参赛者所提交的个人信息及证件信息需真实有效，如提供虚假个人信息或证件信息，将取消个人参赛资格或获奖资格，同时组委会向有关部门如实反映情况;
                          </div>
                          <div class="wenzibox1 weji" style="font-size: 17px;">
                             4、所有获奖的设计作品与形象口号的知识产权归主办方所有，大赛组委会有权利向知识产权局申请知识产权保护，参赛选手不能再次转让、出版或参加展览、比赛等，否则大赛组委会将追究其法律责任;
                          </div>
                           <div class="wenzibox1 weji" style="font-size: 17px;">
                             5．大赛组委会对每位参赛者的参赛作品拥有使用权，有权对作品进行复制、记录、出版、发售、展览、宣传、推广、演绎以及制作成品等用途，其他任何单位和个人不得将获奖作品的设计方案进行宣传、出版或展览等，并不得向第三方转让，否则，组委会将追究其法律责任;
                          </div>
                          <div class="wenzibox1 weji" style="font-size: 17px;">
                             6．参赛作品要求原创，如因抄袭和剽窃他人作品、窃取商业机密而发生知识产权或版权纠纷等均由参赛者自行承担责任，对此大赛组委会有权取消其参赛资格并索回相关奖项;
                          </div>
                         <div class="wenzibox1" style="font-size: 17px;">
                         本大赛参赛免费，不收取报名、参评、参展等费用。
                        </div>
                </div>
        </div> -->
        <!-- <div  class="ikju kiki"  style="margin-top:0px">
                <div class="introduce-box loiss2" style="text-align: left;">
                    <div class="loi lojius" style="font-size: 25px;width:100px;text-align: left;" ref="lightBtn">版权说明</div>
                </div>
                 <div class="wenzi wenzios3" style="margin-left: 170px">
                        <div class="wenzibox1 weji" style="font-size: 17px;">
                             1．所有投稿的作品及相关资料不予退还，参赛者拥有对参赛作品的署名权;
                        </div>
                          <div class="wenzibox1 weji" style="font-size: 17px;">
                            2．本次大赛中作品所涉及的任何商标权、著作权、肖像权、名誉权、隐私权或其他纠纷，均由参赛者或相应参赛团队承担相应法律责任，主办方和协办方概不承担;
                          </div>
                          <div class="wenzibox1 weji" style="font-size: 17px;">
                            3．主办方和协办方自收到参赛作品时起，即有权将该参赛作品用于以宣传目的(包括商业宣传目的)的发布，包括但不限于展示、展览、报道和出版等;
                          </div>
                          <div class="wenzibox1 weji" style="font-size: 17px;">
                            4．获奖参赛作品，主办方即拥有该参赛作品的全部宣传推广权以及该作品的发表权;
                          </div>
                           <div class="wenzibox1 weji" style="font-size: 17px;">
                           5．获奖的参赛作品用于商业用途的，或主办方需进一步完善或开发、设计周边产品的，获奖参赛者或相应参赛团队应予以配合;
                          </div>
                          <div class="wenzibox1 weji" style="font-size: 17px;">
                            6．凡上传作品至本次大赛的作者，主办方均视为同意本次大赛的全部规则，任何经查实不符本次大赛要求的作品，将取消获奖资格;
                          </div>
                           <div class="wenzibox1 weji" style="font-size: 17px;">
                           7．参赛作品内容和形式遵守中国法律法规和相关政策，不得违背社会道德，不得违背公序良俗。作品内容和形式不得出现色情、暴力、反动、侵犯他人隐私及不宜公开传播的内容；
                          </div>
                          <div class="wenzibox1 weji" style="font-size: 17px;">
                          8．主办方对本次大赛保留最终解释权和调整权。
                          </div>
                </div>
        </div> -->
    </div>
              <!-- 大赛评委 -->
              <div class="ikjus"  style="margin-top:0px"  v-animate="'slide-top'">
                  <div class="introduce-box loiss2" style="text-align: left;">
                    <div class="loi lojius kik" style="font-size: 40px;width:250px;text-align: left;" ref="lightBtn">大赛评委</div>
                  </div>
                  <div class="pin-bj">

                  </div>
                  <div class="sao">
                    <img class="sao-img" src="../image/erweima.png"/>
                    <div class="sao-box" style="font-size: 20px;">
                      扫码投稿
                    </div>
                  </div>
              </div>

                <div class="bj"  v-animate="'slide-top'">
                    <!-- <div class="introduce-box introduce-boxssss" style="margin-top:0px;justify-content: center;height:0px;">
                        <h2 class="loi" style="margin-top:0px; font-size:40px;padding:0px;justify-content: center;" >合作品牌</h2>
                    </div> -->
                    <div class="hezuo hezuosss">
                        <div class="hezuo-box" style=" width: 120px;
 height: 1px;background: linear-gradient(to left,#C09255,black);"></div>
                        <div class="hezuo-wen" style="font-size:17px font-weight: 500;
color: #FFFFFF;">合作品牌</div>
                        <div class="hezuo-box2" style="width: 120px;
 height: 1px;
 background:linear-gradient(to right,#C09255,black);"></div>
                    </div>
                    <div class="dui-box22" >
                     <div  class="pinwei-wen2s" style=" height: 14px; font-size: 14px;"  v-for="(item,index) in lists" :key="index">{{item}}</div>
                    </div>
                    <!-- <div class="hezuo">
                        <div class="hezuo-box22" style=" width: 120px;
 height: 1px;background: linear-gradient(to left,#C09255,black);"></div>
                        <div class="hezuo-wen" style="font-weight: 500;
color: #FFFFFF;">媒体支持</div>
                        <div class="hezuo-box222" style="width: 120px;
 height: 1px;
 background:linear-gradient(to right,#C09255,black);"></div>
                    </div>
                    <div class="dui-box1" style="height: 80px;">
                      <div  class="pinwei-wen2s" style=" height: 14px; font-size: 14px;"  v-for="(item,index) in list" :key="index">{{item}}</div>
                    </div> -->
                    <div class="jiewei" style="font-size: 16px;">
                      最终解释权归主办方所有
                    </div>
                    <!-- <div class="kli"></div> -->
              <!-- 大赛进程 -->
              <!-- 大赛进程结束 -->
              
            </div>
             <div class="foie" @click="sucai">
                  <img class="fiex-img" src="../image/sucai.png">
                   <div class="sucai" style="font-size: 14px;">素材下载</div>
              </div> 
            <!-- 进程规则div结束 -->
              
            </div>
        </div>
        <!-- 头部结束 -->
       <!-- <div class="foie">
           <img class="fiex-img" src="../image/icon11.png">
       </div> -->
    <!-- </div>
  </div> -->
  
</template>

<script>
import { isElementNotInViewport} from "@/util/index.js";
import * as config from "@/util/berurl.js";
import qs from 'qs'
export default {
  name: 'HelloWorld',
  data () {
    return {
      videoIsPlay: false,
      video:'https://wenchuang.wcyj2020.com/file/blue-horse-cup-prod/cbo_k_video.mp4',
      imges:config.baseImage,
      list:['人民日报数字四川','人民日报文创','人民网','新华社四川分社','中新社四川分社','中国网四川分社','四川电视台','四川日报','四川在线','川报观察','华西都市报','封面新闻','四川发布','腾讯大成网','新浪四川','搜狐','今日头条','四川文产'],
      lists:['合景·摩方（成都）','蜀之源酒业','高淳陶瓷','茂县羌绣' ,'拙品','北川巴拿恰文创','鹃城牌郫县豆瓣','宽厚'],
      api:config.basePath,
      isFixed:false,//大赛介绍
      banquanType:3,
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods:{
    tiao() {
      window.location.href = 'https://www.cdmuseum.com/'
    },
    // this.$axios({
    //             method:'GET',
    //             url: this.api+'api-cms/notAuth/cmsOfflineNews/list/',
    //            params:{'pageNum': this.pdlist.pageNum, 
    //                 'pageSize':  this.pdlist.pageSize,
    //                 'column':  this.pdlist.column,
    //                 'targetId':this.pdlist.targetId
    //            }
    //         }).then((res) =>{    
    //           if(res.data.code==200) {
                  
    //             this.total = res.data.data.total 
    //             this.lists = res.data.data.records
    //              console.log('数据',this.lists) 
    //             //  console.log('数据3',res.data.data.total)   
    //           }   
               
    //         })
    getpoint(){	
				var local = window.location.href; // 获取页面url
				this.$axios({
					url: this.api+'api-cms/notAuth/activity/point',
					method: 'post',
		      headers: { 'content-type': 'application/x-www-form-urlencoded' },
			  data: qs.stringify({reqPageUrl: local}),
						
				}).then((res) =>{ 

        })
    },
    changeVideoStatus() {
        const video = this.$refs.videoRef;
          if(video.paused) {
            video.play();
          } else {
            video.pause();
          }
        },
    sucai() {
        // let iu ='https://wenchuang-pre.wcyj2020.com' 
        let link = document.createElement('a')
        let url = this.imges+'/file/blue-horse-cup-prod/cb_resource.zip'
        console.log('url22',url)
        link.href = url
        link.target = 'blank'
        link.download = 'attend.xls'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }
  },
  mounted() {
    this.getpoint()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.kiki{
margin-top: 112px !important;
}
/* .wenzios2{
  margin-left: 110px !important;
} */
.wenzios3{
  /* margin-left: 178px !important; */
}
.chendu{
  margin-top: 75px;
}
.chendu2{
  margin-top: 65px;
}
.sucai{
  margin-top: 6px;
  font-weight: 400;
  color: #333333;
}
*{
  margin: 0px;
  padding: 0px;
}
body{
  margin: 0px;
  padding: 0px;
}
.sao{
  margin: auto;
  /* background: yellow; */
  display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.sao-img{
width: 307PX;
height: 307PX;

}
.sao-box{
  margin-top: 48PX;
  width: 301px;
  height: 64px;
  background: #EDC34E;
  border-radius: 32px;
  background: #EDC34E;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 400;
color: #333333;
margin-bottom: 71px;
}
.pin-bj{
  
   background: url(../image/zhuy3.png) no-repeat ;
 /* background-size: container; */
 width: 66%;
 /* background: yellow; */
  height: 1200px;
  margin: auto;
 background-size:cover;
 /* margin-left: 322px; */
 
}
.weji{
  padding-bottom: 50px;
}
.zuop{
  font-family: PingFang SC;
font-weight: bold;
color: #333333;
text-align: left;
padding-bottom: 38px;
}
.wenzio{
  margin-left: 131px !important;
}
.wenzios{
  margin-bottom: 75px !important;
}
.fonsiop2{
  padding-left: 49px;
}
.ikjus{
    /* padding-left: 332px;
  padding-right: 339px; */
   padding-top: 75px;
   padding-bottom: 71px;
background: #F5F5F5;
}
.kik{
     padding-left: 332px;
  padding-right: 339px;
}
.ikju{
  display: flex;
}
.introduce-boxss45678{
   background: url(../image/huod2.png) no-repeat ;
  background-size:100% 100%;
  padding-top: 89px;
  padding-left: 332px;
  padding-right: 339px;
  padding-bottom: 58px;
  background-size: cover;
}
.introduce-boxss4567{
  background: url(../image/zhuy2.png) no-repeat ;
  background-size:100% 100%;
  padding-top: 73px;
  padding-left: 332px;
  padding-right: 339px;
  padding-bottom: 104px;
  background-size: cover;
}
.introduce-boxss456{
  background: url(../image/zhuy.png) no-repeat ;
  background-size:100% 100%;
  padding-top: 66px;
  padding-left: 332px;
  padding-right: 339px;
  padding-bottom: 71px;
  display: flex;
  background-size: cover;
}
.introduce-boxss45{
  background: url(../image/huod.gif) no-repeat;
  /* background-size:100% 100%; */
  padding-top: 74px;
  padding-left: 332px;
  padding-right: 339px;
  padding-bottom: 122px;
  background-size: cover;
}
.jkrt{
  display: flex;
  position: relative;
   padding-top: 145px;
   padding-bottom: 59px;
}
.lojius{
  font-weight: 400;
color: #333333 !important;
}
.introduce-boxssss{
padding-top:94px;
padding-left: 0px !important;
padding-right: 0px !important;

}
.hezuosss{
  padding-top: 88px;
  /* margin-top:88px !important; */
  font-weight: 500 !important;
color: #FFFFFF !important;
}
.bj{
 background: url(../image/weibu.gif) no-repeat center;
  /* background-size:100% 100%; */
 padding-bottom: 100px;
 background-size: cover;

}
.foie{
  position: fixed;
  top: 74%;
  right: 100px;
   /* transform: translate(0%, 50%); */
   width: 100px;
height: 100px;
background: #FFFFFF;
box-shadow: 0px 4px 11px 2px rgba(68, 64, 0, 0.1);
border-radius: 50%;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
}
.fiex-img{
  width: 55px;
  height: 41px;
}
.slide-top {
	-webkit-animation: slide-top 1.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
	        animation: slide-top 1.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}
@-webkit-keyframes slide-top {
  0% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
  100% {
    -webkit-transform: translateY(-200px);
            transform: translateY(-200px);
  }
}
@keyframes slide-top {
  0% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
  100% {
    -webkit-transform: translateY(-200px);
            transform: translateY(-200px);
  }
}
.bhhy{
  margin-top: -22px

}
.kli{
  /* margin-top: 168px; */
  height: 128px;
}
.jiewei{
  font-weight: 500;
color: #C09255;
  font-size: 24px;
  /* margin-bottom: 160px; */
  margin-top: 12px;
  display: flex;
  justify-content: center;
}
.pinwei-wen2s{
  border-right:1px solid #C6C6C6 ;
  padding-right:20px;
  padding-left:20px;
  font-size: 28px;
  margin-bottom: 15px;
  display: flex;
    align-items: center;
    font-weight: 400;
color: #FFFFFF;
   
}
.dui-box1:after {
	    content: '';
		 width: 744px; 
	}
.dui-box1{
   display: flex;
  align-items: center;
  padding-left: 74px;
  /* padding-right: 501px; */
  /* width: 40%; */
  margin: auto;
 /* justify-content: space-between; */
 margin-bottom: 71px;
 flex-flow: wrap;
 width: 744px;
}
.dui-box22{
   display: flex;
  align-items: center;
justify-content: center;

  /* padding-right: 501px; */
  /* width: 40%; */
  margin: auto;
 /* justify-content: space-between; */
 margin-bottom: 71px;
 flex-flow: wrap;

}
.duix{
  display: flex;
  align-items: center;
  /* width: 66%;
  margin: auto; */
  /* justify-content: space-between; */
}
.duix-box{
  /* color: #3F8068; */
   padding-right: 58px;
    /* padding-left: 68px; */
    height: 30px;
    width: 1px;
    /* background: yellow; */
    border-right:1px solid #C09255 ;
}
.duix-imgs{
  width: 80px;
  height: 80px;
 
}
.hezuo{
  display: flex;
  align-content: center;
  /* background: yellow; */
  /* margin-top: 10px; */
  justify-content: center;
    align-items: center;
    margin-bottom: 70px;
}
.hezuo-wen{
color: #3E514F;
font-size: 30px;
padding-left: 26px;
padding-right: 26px;
}
.hezuo-box{
 width: 170px;
 height: 1px;
 /* border-top: 1px solid #7CA4A0; */
 background:linear-gradient(to left,#C09255,black);
 /* background:linear-gradient(to left,#efefef,#ff72a3); */
  /* background:linear-gradient(to right,#efefef,#ff72a3); */
 /* background:linear-gradient(to right,#7CA4A0,#FFFFFF); */
}
.hezuo-box2{
 width: 170px;
 height: 1px;
 background:linear-gradient(to right,#C09255,black);
}
.hezuo-box222{
 width: 170px;
 height: 1px;
 background:linear-gradient(to right,#C09255,black);
}
/* h2{
  margin-top: 40px !important;
} */
.pinwei-wen2{
  font-size: 24px;
  display: flex;
    align-items: center;
    justify-content: center;
    width: 343px;
    text-align: initial;
}
.pinwei-wen{
  color: #3E514F;
  font-size: 36px;
  
}
.pinwei-box{
  /* border: 1px solid #3F8068; */
  height: 1px;
  /* width: 40px; */
  margin-bottom: 15px;
  margin-top: 10px;
  color: #3F8068;
  display: flex;
    align-items: center;
    justify-content: center;
}
.pinwei-imgs2{
  width: 343px;
  height: 343px;
 margin-bottom: 46px;
}
.pinwei{
  width: 66%;
  margin: auto;
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
  margin-bottom: 116px;
}
h4{
  text-align: left;
  margin: 0px;
  margin-bottom: 27px;
}
.sheji-imgs{
 background: url(../image/fa2.png) no-repeat ;
width: 612px;
height: 358px;
border-radius: 0px 20px 0px 20px;
background-size: 100% 100%;
 transition: all 1s;

}
.sheji-imgs2{
  background: url(../image/fa.png) no-repeat ;
width: 612px;
height: 358px;
border-radius: 0px 20px 0px 20px;
background-size: 100% 100%;
 transition: all 1s;

}
.sheji-imgs2:hover{
    background-size: 110% 110%;
}
.sheji-imgs:hover{
    background-size: 110% 110%;
}
.she-dis{
 display: flex;
  /* flex-direction: column; */
  align-items: center;
  /* padding-left: 40px;
  padding-right: 36px;
  padding-top: 110px; */
  /* padding-bottom: 99px; */
  background:rgba(0,0,0,0.5);
  border-radius: 0px 20px 0px 20px;
  /* height: 248px; */
  height: 100%;
  justify-content: center;
}
.she-dis2{
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  justify-content: center;
  /* padding-left: 40px;
  padding-right: 36px;
  padding-top: 110px; */
  /* padding-bottom: 99px; */
  background:rgba(0,0,0,0.5);
  border-radius: 0px 20px 0px 20px;
  /* height: 248px; */
  height: 100%;
}
.sheji-wen{
 font-size: 40px;
    font-family: FZXiaoBiaoSong-B05S;
    font-weight: 400;
    color: #FFFFFF;
    /* margin-bottom: 50px; */
}
.sheji-wen2{
 font-size: 24px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 36px;
  text-align: initial;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
overflow: hidden;
color: #FFFFFF;
}
.sheji{
  margin: auto;
  display: flex;
  justify-content: space-between;
  margin-top: 73px;
  margin-bottom: 97px;
  position: relative;
}
.jiu-box2{
  margin-bottom: 86px;
}
.jiu-box{
  display: flex;
  justify-content: space-between;
}
.body-box-imgs2{
  width: 355px;
  height: 329px;
}
.jiu{
  margin: auto;
  margin-top: 100px;
  
}

.hello {
  /* background: red; */
  /* background: #FFFBEE ; */
   background: url(../image/huod2.png) no-repeat ;
  background-size: cover;
  overflow-x: hidden;
   height: 100vh;
font-size:0;
  /* overflow-y: scroll */
  /* height: 12000px; */
}
/* html{
 background: url(../image/huod2.png) no-repeat ;

  background-size: cover;
  
} */
.gui-box2{
  display: flex;
   height: 56px;
   align-content: center;
   width: 66%;
    margin: auto;
   /* margin-bottom: 30px; */
  /* justify-content: end; */
}
.gui-box-img{
  width: 40px;
  height: 56px;
  padding-right: 20px;
}
.gui-box-wen{
  color: #C1750C ;
  font-size: 36px;
  border-bottom:1px solid #C1750C 
}
.gui-box{
  /* width: 66%; */
  margin: auto;
  background: #FFFBEF;
  /* margin-top: 169px; */
  /* padding-top: 200px; */
  margin-top: 200px;
}
.gui-box12{
  /* width: 66%; */
  margin: auto;
  /* height: 5200px; */
  background: #FFFBEF;
  height: 2000px;
  /* margin-top: 169px; */
  margin-top: 70px !important;
}
.body-box-imgss{
  width: 351px;
  height: 351px;
}
.body-box-imgss3{
  width: 800px;
  height: 351px;
  border-radius: 24px;

}
.jian-img{
 display: flex;
  justify-content: space-between;
  margin-top: 62px;
}
.wenzibox1{
  text-align: initial;
}
.wenzi{
  /* margin: auto; */
  /* padding-left: 129px; */
  /* padding-bottom: 20px;
  padding-top: 20px; */
color: #333333;
  font-size: 24px;
  /* width: 90%; */
 line-height: 40px;
  z-index: 1000;
  /* margin-left: 129px; */
  /* background: yellow; */
}
.loi{
  display: flex;
  /* justify-content: center; */
  /* width: 350px;
  padding-left: 32px;
  padding-right: 32px;
  font-size: 60px; */
  font-weight: 400;
  color: #FFFFFF;
}
.body-box-imgs{
  width: 189px;
  height: 78px;
}
.introduce-box{
  /* display: flex;
  justify-content: space-between;
  margin: auto;
  align-items: center;
  margin-top: 129px;
  padding-left: 652px;
  padding-right: 610px; */
  position: relative;
}
.loiss2{
  /* padding-top: 145px; */
}
.introduce-box-hen1{
  position: absolute;
  top: 82px;
  left: 0px;
  width: 352px;
height: 1px;
border-top: 1px solid  #C09255;
/* background: #C09255; */
}
.introduce-box-hen11{
  position: absolute;
  top: -55px;
  left: 0px;
  width: 352px;
height: 1px;
border-top: 1px solid  #C09255;
/* background: #C09255; */
}
.introduce-box-hen2{
  position: absolute;
  top: 82px;
  left: 352px;
 width: 904px;
height: 1px;
border-top: 1px solid #BFBFBF;
/* background: #BFBFBF; */
}
.introduce-box-hen12{
  position: absolute;
  top: -55px;
  left: 352px;
 width: 904px;
height: 1px;
border-top: 1px solid #BFBFBF;
/* background: #BFBFBF; */
}
.introduce-box-hen3{
  position: absolute;
  top: 26px;
  left: 284px;
 width: 1px;
height: 200px;
border-right: 1px solid #BFBFBF;
/* background: #BFBFBF; */
}
.introduce-box-hen13{
  position: absolute;
  top: -55px;
  left: 284px;
 width: 1px;
height: 420px;
border-right: 1px solid #BFBFBF;
/* background: #BFBFBF; */
}
.introduce-boxs{
  display: flex;
  justify-content: space-between;
  margin: auto;
  /* background: red; */
  align-items: center;
 /* max-width: 470px; */
  margin-top: 287px;
  padding-left: 652px;
  padding-right: 610px;
}
.introduce {
  /* height: 1173px; */
  /* background: #FFF5DA;
  z-index: 100;
  padding-top: 263px; */
 background: url(../image/huod2.png) no-repeat ;
  background-size:100% 100%;
  padding-bottom: 79px;
  /* padding-top: 82px; */
  padding-left: 332px;
  padding-right: 339px;
  margin-top: 200px;
background-size: cover;
}
.box{
  width: 1920px;
  height: 90vh;
  /* background: #FFF5DA; */
  /* width: 100%; */
  position: relative;
}
.thehead-box{
  width: 100%;
  height: 120px;
  background: #A49979 ;
}
.thehead{
  width: 70%;
  margin: auto;
  /* background: yellow; */
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
}
.img-box{
  width: 50%;
  /* background: red; */
  text-align: initial;
}
.imge{
  width: 135px;
  height: 80px;
}
.thehead-box2{
  flex: 1;
  display: flex;
  justify-content: space-between;
  height: 100%;
  align-items: center;
}
.thehead-fengt{
  color: #FFFFFF;
  font-size: 30px;
}
.thehead-body{
  width: 100%;
  background: #CDBF97;
  position: relative;
}
.body-box{
  width: 100%;
  margin: auto;
  height: 1080px;
  /* background: yellow; */
  /* background: url(../image/icon10.png) no-repeat ;
  background-size:100% 100%; */
  /* margin-bottom: 200px; */
  /* width: 960px; */
  /* height: 100%; */

}
.body-box-img{
   width: 100%; 
 
   /* height: 100%; */
}
 .duix:last-child .duix-box{
 border:none
}
 .pinwei-wen2s:last-child{
 border:none
}
 /* .pinwei-wen2s:nth-child(6){
 border:none
} */
.videos{
  position: relative;
  height: 1080px;
  /* width: 1256px; */
  width: 100%;
  /* height: 890px; */
  /* position: absolute; */
  /* top:500px; */
  /* background: yellow; *
  /* z-index: 1; */
}
.start-play {
  cursor: pointer;
  width: 83px;
  height: 83px;
  border: 1px solid #FFFFFF;
  /* background: linear-gradient(135deg, #1890FF 0%, #0059F4 100%); */
  opacity: 0.7;
  border-radius: 50%;
  display: block;
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
 
}
 .start-play::after {
    content: "";
    width: 0;
    height: 0;
    border: 18px solid transparent;
    border-left: 29px solid white;
    position: absolute;
    top: 28%;
    left: 40%;
   
  }

</style>



// WEBPACK FOOTER //
// src/components/home.vue